import { h } from 'preact';
import { useRef } from 'preact/hooks';
import HeartIcon from 'utils/icon/icon-heart.svg';
import ChatIcon from 'utils/icon/icon-chat.svg';
import GiftCardIcon from 'utils/icon/icon-gift-card.svg';
import LanguageIcon from 'utils/icon/icon-language.svg';
import clsx from 'clsx';

const MenuButton = ({ type, settings, locales }) => {
  const menuLanguageForm = useRef(null);
  const localeCode = useRef(null);

  if (type === 'Wishlist') {
    const url = settings?.link ? settings.link : '#swym-wishlist';

    return (
      <a href={url} className="swym-wishlist swym-wishlist--mobile flex gap-10">
        <HeartIcon
          className={clsx('w-20 flex-none h-auto', {
            'fill-current': window.swymCount > 0,
          })}
        />
        <span className="body-2 ml:body-3">
          {window.TMW.Strings.general.wishlist}
        </span>
      </a>
    );
  }
  if (type === 'GiftCard') {
    const url = 
      `${
        Shopify.routes.root  
      }pages/${ 
        window.TMW.Strings.giftCard.pageUrl
    }`;

    return (
      <a href={url} className="swym-wishlist swym-wishlist--mobile flex gap-10">
        <GiftCardIcon
          className={clsx('w-24 flex-none h-auto')}
        />
        <span className="body-2 ml:body-3 mt-4">
          {window.TMW.Strings.giftCard?.giftCards}
        </span>
      </a>
    );
  }
  if (type === 'Language') {
    const locale = locales.find((item) => item.iso_code !== Shopify.locale);
    if (locale) {
      const handleClick = (event) => {
        event.preventDefault();

        localeCode.current.value = locale.iso_code.toLowerCase();
        localStorage.setItem('tmwLocale', locale.iso_code.toLowerCase());
        sessionStorage.setItem('mobileMenuLanguageSelector', true);

        if (menuLanguageForm) menuLanguageForm.current.submit();
      };

      return (
        <form
          method="post"
          action="/localization"
          id="MenuLanguageForm"
          acceptCharset="UTF-8"
          encType="multipart/form-data"
          ref={menuLanguageForm}
        >
          <input type="hidden" name="form_type" value="localization" />
          <input type="hidden" name="utf8" value="✓" />
          <input type="hidden" name="_method" value="put" />
          <input
            type="hidden"
            name="return_to"
            value={`${window.location.pathname.replace(
              Shopify.routes.root,
              locale.url,
            )}`}
          />
          <div className="no-js-hidden">
            <div className="disclosure">
              <div className="disclosure__list-wrapper">
                <ul
                  id="MenuLanguageList"
                  role="list"
                  className="disclosure__list list-unstyled flex gap-16"
                >
                  <li
                    className="disclosure__item flex gap-10 items-center"
                    tabIndex="-1"
                  >
                    <LanguageIcon className="w-24 flex-none h-auto" />
                    <a
                      onClick={handleClick}
                      className="body-2 ml:body-3 uppercase"
                      href="#"
                      hrefLang={`${locale.iso_code}`}
                      lang={`${locale.iso_code}`}
                      data-value={`${locale.iso_code}`}
                    >
                      {locale.iso_code}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <input
              type="hidden"
              name="locale_code"
              value={`${locale.iso_code}`}
              ref={localeCode}
            />
          </div>
        </form>
      );
    }
  }
  if (type === 'Assistance') {
    return (
      <a href={settings.link} className="flex gap-10 items-center">
        <ChatIcon className="w-24 flex-none h-auto" />
        <span
          className="body-2 ml:body-3"
          dangerouslySetInnerHTML={{ __html: settings.label }}
        ></span>
      </a>
    );
  }
  return null;
};
const MobileMenuBottom = ({ logo, link, buttons, locales }) => (
  <div className="bg-accent-1 px-24 pt-16 pb-40 flex flex-col gap-24">
    <div className="flex flex-col gap-24">
      {buttons.map((button) => (
        <MenuButton {...button} locales={locales} key={button.type} />
      ))}
    </div>
    {!!logo && (
      <div>
        <div className="body-6 text-subdued mb-8">
          {window.TMW.Strings.general.discover}
        </div>
        <a
          href={link}
          dangerouslySetInnerHTML={{ __html: logo }}
          className="[&_svg]:max-w-full [&_svg]:block [&_svg]:w-auto lc:[&_svg]:h-16 ml:[&_svg]:h-18"
        ></a>
      </div>
    )}
  </div>
);

export default MobileMenuBottom;
